import { render, staticRenderFns } from "./BloqueSitios.vue?vue&type=template&id=0a8ab9fa"
import script from "./BloqueSitios.vue?vue&type=script&lang=js"
export * from "./BloqueSitios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports